import { FC, useEffect, ReactNode } from 'react';
import { Cards, VerticalLogo } from '@dynamika-shared/ui/icons';
import { ClinicalTrialList } from './ClinicalTrialList/ClinicalTrialList';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { useSettingsSlice } from '@restore/settings/settings.slice';

type SelectClinicalTrialViewProps = {
  onSelect: (clinicalTrial: ClinicalTrialAffiliatesType) => void;
  subTitle: string | ReactNode;
};
export const SelectClinicalTrialView: FC<SelectClinicalTrialViewProps> = ({
  onSelect,
  subTitle,
}) => {
  const [dataCT, fetchClinicalTrialAffiliates, loading] =
    useClinicalTrialAffiliatesSlice((state, actions) => [
      state.data,
      actions.fetchClinicalTrialAffiliates,
      state.loading,
    ]);
  const setBusinessVersion = useSettingsSlice((_, a) => a.setBusinessVersion);

  useEffect(() => {
    fetchClinicalTrialAffiliates(null);
  }, []);

  useEffect(() => {
    const fetchBusinessVersion = async () => {
      try {
        const response = await fetch('/assets/version.txt');

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const versionText = await response.text();

        if (versionText) {
          setBusinessVersion(versionText.trim());
        }
      } catch (error) {
        console.error('Error fetching version file:', error);
      }
    };

    fetchBusinessVersion();
  }, []);

  return (
    <div className='flex h-full w-full items-center justify-center'>
      <div className='mb-[11rem] flex h-fit max-h-[584px]  w-[440px] flex-col items-center rounded-[24px] bg-white px-3 py-2 shadow-modalLight'>
        <VerticalLogo className='mb-6 mt-3 min-h-[92px] min-w-[92px]' />
        {dataCT.length ? (
          <>
            <h2 className='mb-1.5 text-[24px] font-semibold text-black'>
              Select Clinical Trial
            </h2>
            <p className='mb-5 text-1824 text-spanishGray'>{subTitle}</p>
            <div className='w-full overflow-y-auto overflow-x-hidden'>
              <ClinicalTrialList
                clinicalTrials={dataCT}
                handleSelectCT={onSelect}
                context='selectCT'
                loading={loading}
              />
            </div>
          </>
        ) : (
          !loading && (
            <div className='mb-[15rem]'>
              <div className='mb-2 mt-[9.6rem]'>
                <Cards width='256px' height='88px' />
              </div>
              <div className='text-center'>
                <span className='text-1624 text-spanishGray'>
                  No{' '}
                  <span className='font-semibold text-chineseBlack'>
                    Clinical Trials{' '}
                  </span>
                  for
                  <br />
                  you here yet!
                </span>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
